import React from 'react';
import { Helmet } from 'react-helmet';

const Terms = () => {
  const styles = {

    header: {
      color: 'var(--darkpurple)',
      fontSize: '2rem',
      textAlign: 'center',
      marginBottom: '20px',
    },
    sectionHeader: {
      color: 'var(--darkpurple)',
      fontSize: '1.5rem',
      marginBottom: '10px',
      marginTop: '20px',
    },
    paragraph: {
      fontSize: '1rem',
      color: 'var(--darkpurple)',
      lineHeight: '1.6',
      marginBottom: '10px',
    },
    list: {
      listStyleType: 'circle',
      paddingLeft: '20px',
      marginBottom: '10px',
    },
    contactList: {
      paddingLeft: '20px',
    },
    listItem: {
      marginBottom: '8px',
    },
  };

  return (

<>

<Helmet>
 
  <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "Om Sai PG",
      "description": "Om Sai PG offers affordable PG accommodations in Kharadi, Pune, with food, for students, working professionals, and residents, near Eon IT Park.",
      "url": "https://www.omsaipg.in",
      "logo": "https://www.omsaipg.in/images/logo.jpg",
      "image":"https://www.omsaipg.in/images/ogimage.jpg",
      "contactPoint": [
        {
          "@type": "ContactPoint",
          "telephone": "+91 9763888448",
          "contactType": "Customer Service",
          "areaServed": "IN",
          "availableLanguage": "English",
        },
        {
          "@type": "ContactPoint",
          "telephone": "+91 9922248255",
          "contactType": "Customer Service",
          "areaServed": "IN",
          "availableLanguage": "English",
        },
      ],
      "aggregateRating": {
        "@type": "AggregateRating",
        "bestRating": "5",
        "worstRating": "1",
        "ratingValue": "4.7",
        "ratingCount": "250",
      },
      "email": "omsaipg@gmail.com",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Tulja Bhavani Nagar, Lane No 7, Near Durga Mata Mandir",
        "addressLocality": "Kharadi",
        "addressRegion": "Maharashtra",
        "postalCode": "411014",
        "addressCountry": "IN",
      },
      "sameAs": [
        "https://www.facebook.com/omsaipg",
        "https://www.instagram.com/omsaipg",
        "https://www.linkedin.com/company/omsaipg"
      ],
      "priceRange": "INR 8,500-6000",
      "paymentAccepted": "Cash, UPI, Credit Card",
      "telephone": "+91 9763888448",
      "email": "omsaipgpune@gmail.com",
      "keywords": [
        "PG in Pune",
        "PG in Kharadi",
        "PG with food in Pune",
        "PG for students in Kharadi",
        "PG for females in Pune",
        "PG for males in Pune",
        "Om Sai PG Kharadi",
        "Girls Hostels in Kharadi",
        "Boys Hostel in Kharadi",
        "Monthly Basis PG in Kharadi",
        "PG in Wagholi",
        "PG in Kharadi with food",
        "Hostels in Pune",
        "PG for Students in Kharadi Pune",
        "Paying Guest Hostel in Chandan Nagar"
      ],
      "openingHours": "Mo-Su 09:00-22:00"
    })}
  </script>

  {/* Title */}
  <title>
    Contact : +91 9763888448 / +91 9922248255 | Om Sai PG |Terms & Condition| PG for Working Professionals Pune | Luxury PG in Kharadi | Paying Guest Near Kharadi IT Park Pune
  </title>

  {/* Meta Tags */}
  <meta
    name="description"
    content="Om Sai PG offers the best PG accommodations in Kharadi, Pune. We provide PG for students, males, females, with food and other essential amenities."
  />
  <meta
    name="keywords"
    content="PG in Pune, PG in Kharadi, PG for Working Professionals Pune, Luxury PG in Kharadi, Paying Guest Near Kharadi IT Park Pune, PG Near Kharadi Eon IT Park
"
  />
  <meta name="robots" content="index, follow" />

  {/* Open Graph Tags */}
  <meta
    property="og:title"
    content="Om Sai PG - Best PG Accommodation in Kharadi Pune | PG with Food | Paying Guest in Kharadi"
  />
  <meta
    property="og:description"
    content="Looking for the best PG in Kharadi Pune? Om Sai PG offers comfortable and affordable accommodation for students, professionals, and residents with food included."
  />
  <meta property="og:image" content="https://www.omsaipg.in/ogimage.jpg" />
  <meta property="og:url" content="https://www.omsaipg.in" />
  <meta property="og:type" content="website" />
</Helmet>

<section class="section-breadcrumb padding-b-50">
        <div class="rx-breadcrumb-image bg-img1">
            <div class="rx-breadcrumb-overlay"></div>
            <div class="inner-breadcrumb-contact">
                <div class="main-breadcrumb-contact">
                    <div class="container">
                        <div class="row">
                            <div class="col-12">
                                <div class="rx-banner-contact">
                                    <h2>Terms & Condition</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="rx-banner-breadcrumb">
                    <div class="container">
                        <div class="row">
                            <div class="col-12">
                                <div class="breadcrumb-contact">
                                    <div class="main-heading">
                                        <h4>Terms & Condition</h4>
                                    </div>
                                    <div class="last-contact">
                                        <ul>
                                            <li>
                                                <a href="index.html">Home</a>
                                            </li>
                                            <li>Terms & Condition</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>



    <div className='container'>
      <h2 style={styles.header}>Terms and Conditions for Om Sai PG</h2>
      <p style={styles.paragraph}>Welcome to Om Sai PG! Please read the following terms and conditions carefully before booking your accommodation at Om Sai PG. By making a reservation, you agree to the terms and conditions outlined below.</p>

      <h3 style={styles.sectionHeader}>General Information</h3>
      <p style={styles.paragraph}>Om Sai PG is a residential accommodation facility located in Kharadi, near Eon IT Park. We offer PG rooms in two separate buildings, each equipped with essential amenities for a comfortable stay.</p>
      
      <h3 style={styles.sectionHeader}>Facilities Provided</h3>
      <ul style={styles.list}>
        <li style={styles.listItem}>Washing Machine for laundry needs</li>
        <li style={styles.listItem}>Wi-Fi for seamless internet connectivity</li>
        <li style={styles.listItem}>TV in each room for entertainment</li>
        <li style={styles.listItem}>24/7 Water Supply for uninterrupted comfort</li>
        <li style={styles.listItem}>Geyser for hot water</li>
        <li style={styles.listItem}>2-Wheeler Parking available for your convenience</li>
        <li style={styles.listItem}>Fridge for storing perishables</li>
        <li style={styles.listItem}>Gas connection for cooking</li>
        <li style={styles.listItem}>24-Hour Hot Water supply</li>
        <li style={styles.listItem}>Free Housekeeping services</li>
        <li style={styles.listItem}>Free Electric Bills to keep your expenses low</li>
        <li style={styles.listItem}>Purified Drinking Water for your health and safety</li>
        <li style={styles.listItem}>CCTV Surveillance for your security</li>
      </ul>

      <h3 style={styles.sectionHeader}>Room Options and Pricing</h3>
      <ul style={styles.list}>
        <li style={styles.listItem}>1 Sharing Room: ₹8,500 per month (including breakfast and dinner)</li>
        <li style={styles.listItem}>2 Sharing Room: ₹7,000 per month (including breakfast and dinner)</li>
        <li style={styles.listItem}>3 Sharing Room: ₹6,000 per month (including breakfast and dinner)</li>
      </ul>

      <h3 style={styles.sectionHeader}>Deposit and Payment</h3>
      <p style={styles.paragraph}>All bookings require a deposit of ₹3,000 and one month's advance rent. Payments must be made before check-in.</p>

      <h3 style={styles.sectionHeader}>Cancellation Policy</h3>
      <p style={styles.paragraph}>In case of cancellation, a 50% refund will be provided if done at least 7 days before the scheduled check-in date. No refunds will be given for cancellations within 7 days of check-in.</p>

      <h3 style={styles.sectionHeader}>Contact Information</h3>
      <p style={styles.paragraph}>If you have any questions or would like to make a booking, please contact us at:</p>
      <ul style={styles.contactList}>
        <li style={styles.listItem}>Phone: 9763888448</li>
        <li style={styles.listItem}>Phone: 9922248255</li>
      </ul>

      <h3 style={styles.sectionHeader}>Additional Terms</h3>
      <ul style={styles.list}>
        <li style={styles.listItem}>All residents must adhere to the house rules and respect the privacy and peace of others.</li>
        <li style={styles.listItem}>Any damage to the property or its contents will be charged to the resident.</li>
        <li style={styles.listItem}>Visitors are allowed but should be registered at the reception and must adhere to the rules.</li>
        <li style={styles.listItem}>Om Sai PG is not responsible for any loss of personal belongings. Residents are advised to take care of their valuables.</li>
        <li style={styles.listItem}>We reserve the right to terminate the stay of any resident who violates the terms and conditions or engages in unlawful activities.</li>
      </ul>
    </div>

    </>
  );
};

export default Terms;
